import { render, staticRenderFns } from "./SideConfig.vue?vue&type=template&id=e1039f12&scoped=true"
import script from "./SideConfig.vue?vue&type=script&lang=js"
export * from "./SideConfig.vue?vue&type=script&lang=js"
import style0 from "./SideConfig.vue?vue&type=style&index=0&id=e1039f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1039f12",
  null
  
)

export default component.exports